<h2 mat-dialog-title>
  <mat-icon svgIcon="price_change"></mat-icon>
  Prisregulering for adgangsgrupper
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <ok-feedback-info>
    <div>
      <strong>Bemærk:</strong>
      <p>Der kan kun bruges én type prisregulering pr. lokation</p>
    </div>
  </ok-feedback-info>

  <div class="multi-select margin--bottom-none">
    <div class="multi-select__list multi-select__list--grid">
      @if (uniquePriceRegulations().length > 0) {
        <div class="multi-select__headers">
          <div class="multi-select__item--name">Prisregulering</div>
          <div class="multi-select__item--access-group">Adgangsgruppe(r)</div>
          <div></div>
          <div></div>
        </div>
        @for (priceRegulation of uniquePriceRegulations(); track priceRegulation.versionId) {
          <div
            class="multi-select__item multi-select__item--tall"
            [class.highlight]="priceRegulation.ref.identifier === lastSavedPriceRegulationId()">
            <div class="multi-select__item--name">
              {{ priceRegulation.name }}
              @if (priceRegulation.type === 'SupplementOverride') {
                <div class="price-regulation-details">
                  @if (priceRegulation.okSupplement !== null && priceRegulation.okSupplement !== undefined) {
                    Fast pristillæg - OK-tillæg
                    <strong>{{ priceRegulation.okSupplement | dkCurrency }}</strong>
                    ekskl. moms
                    <br />
                  }
                  @if (priceRegulation.orgSupplement !== null && priceRegulation.orgSupplement !== undefined) {
                    Fast pristillæg - kundetillæg
                    <strong>{{ priceRegulation.orgSupplement | dkCurrency }}</strong>
                    ekskl. moms
                  }
                </div>
              } @else if (priceRegulation.discount !== null) {
                Rabat (kr./kWh)
                <strong>{{ priceRegulation.discount | dkCurrency }}</strong> ekskl. moms
              }
            </div>
            <div class="multi-select__item--access-group">
              @for (accessGroup of accessGroupsFor(priceRegulation.name); track accessGroup.identifier) {
                <a
                  class="blue accessgroup-link"
                  mat-dialog-close
                  [routerLink]="['/access-groups']"
                  [queryParams]="{ accessGroupIdentifier: accessGroup.identifier }">
                  {{ accessGroup.name }}
                </a>
              }
            </div>
            <button mat-icon-button title="Rediger" type="button" (click)="edit(priceRegulation.ref)">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
            </button>
            <button mat-icon-button class="delete" title="Slet" type="button" (click)="delete(priceRegulation.ref)">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
            </button>
          </div>
        }
      }
      <div class="multi-select__input">
        <form class="filter-dropdown" [formGroup]="formGroup">
          @if (editingPriceRegulation(); as editing) {
            <mat-form-field class="price-regulation-field">
              <mat-label>Prisregulering</mat-label>
              <input matInput [value]="editing.name" disabled />
            </mat-form-field>
          } @else {
            <adm-type-ahead-selector2
              class="price-regulation-select"
              label="Søg prisregulering"
              identityPropertyName="identifier"
              [fetchFn]="fetchPriceRegulationsFn"
              [itemTemplate]="priceRegulationTemplate()"
              [validationControl]="formGroup.controls.priceRegulationIdentifier"
              [resetTrigger]="typeAheadResetTrigger()"
              (itemSelected)="onPriceRegulationSelected($event)">
            </adm-type-ahead-selector2>
          }
          <adm-admin-enum-select-list-multiple
            label="Adgangsgruppe(r)"
            [enumObject]="accessGroups()"
            [translatePipe]="accessGroupTranslatePipe()"
            [initialValue]="selectedAccessGroupIds()"
            [template]="accessGroupTemplate()"
            (enumChanged)="onAccessGroupsChanged($event)">
          </adm-admin-enum-select-list-multiple>
          @if (editingPriceRegulation()) {
            <button mat-flat-button color="primary" (click)="saveEdit()" class="add-button" [disabled]="!canSubmit()">Gem</button>
            <button mat-icon-button (click)="cancelEdit()" class="cancel-button" [matTooltip]="'Annuller redigering'">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          } @else {
            <button mat-flat-button color="primary" (click)="create()" class="add-button" [disabled]="!canSubmit()">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
            </button>
          }
        </form>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="unit-identifier">
    <span>Lokation:</span>
    {{ data.locationName }}
  </div>
  <button mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>

<ng-template #priceRegulationItemTemplate let-priceRegulation>
  <div class="price-regulation-option">
    <span class="price-regulation-option-name">{{ priceRegulation.name }}</span>
    @if (priceRegulation.type === 'SupplementOverride') {
      <div class="price-regulation-details">
        @if (
          priceRegulation.ok_supplement_override_in_kr_without_vat !== null &&
          priceRegulation.ok_supplement_override_in_kr_without_vat !== undefined
        ) {
          <span class="price-regulation-option-supplement">
            Fast pristillæg - OK-tillæg
            <strong>{{ priceRegulation.ok_supplement_override_in_kr_without_vat | dkCurrency }}</strong>
            ekskl. moms
          </span>
        }
        @if (
          priceRegulation.organization_supplement_override_in_kr_without_vat !== null &&
          priceRegulation.organization_supplement_override_in_kr_without_vat !== undefined
        ) {
          <span class="price-regulation-option-supplement">
            Fast pristillæg - kundetillæg
            <strong>{{ priceRegulation.organization_supplement_override_in_kr_without_vat | dkCurrency }}</strong>
            ekskl. moms
          </span>
        }
      </div>
    } @else if (priceRegulation.discount_amount_in_kr_without_vat !== null) {
      <div class="price-regulation-details">
        Rabat (kr./kWh)
        <strong>{{ priceRegulation.discount_amount_in_kr_without_vat | dkCurrency }}</strong> ekskl. moms
      </div>
    }
  </div>
</ng-template>

<ng-template #accessGroupItemTemplate let-accessGroup>
  <span class="access-group-option-name">{{ accessGroup.name }}</span>
  <span class="access-group-option-car-type">Biltype: {{ accessGroup.car_type | translateAccessGroupCarTypeEnum }}</span>
</ng-template>
